export default {
  IconBrowserChrome: () => import('./IconBrowserChrome.vue'),
  IconBrowserEdge: () => import('./IconBrowserEdge.vue'),
  IconBrowserFirefox: () => import('./IconBrowserFirefox.vue'),
  IconBolt: () => import('./IconBolt.vue'),
  IconFire: () => import('./IconFire.vue'),
  IconChat: () => import('./IconChat.vue'),
  IconAppleShare: () => import('./IconAppleShare.vue'),
};
